import Vue from "vue";
import Vuex from "vuex";
import { state, getters, actions, mutations } from "./mutations";
import * as practice from "./practice";
import * as interview from "./interview";
import * as patientQueue from "./patientQueue";
import * as trend from "./trend";
import * as encounter from "./encounter";
import * as symptom from "./symptom";
import * as careTemplate from "./careTemplate";
import * as settings from "./settings";

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    practice: {
      namespaced: true,
      state: practice.state,
      getters: practice.getters,
      actions: practice.actions,
      mutations: practice.mutations
    },
    interview: {
      namespaced: true,
      state: interview.state,
      getters: interview.getters,
      actions: interview.actions,
      mutations: interview.mutations
    },
    patientQueue: {
      namespaced: true,
      state: patientQueue.state,
      getters: patientQueue.getters,
      actions: patientQueue.actions,
      mutations: patientQueue.mutations
    },
    trend: {
      namespaced: true,
      state: trend.state,
      getters: trend.getters,
      actions: trend.actions,
      mutations: trend.mutations
    },
    encounter: {
      namespaced: true,
      state: encounter.state,
      getters: encounter.getters,
      actions: encounter.actions,
      mutations: encounter.mutations
    },
    symptom: {
      namespaced: true,
      state: symptom.state,
      getters: symptom.getters,
      actions: symptom.actions,
      mutations: symptom.mutations
    },
    careTemplate: {
      namespaced: true,
      state: careTemplate.state,
      getters: careTemplate.getters,
      actions: careTemplate.actions,
      mutations: careTemplate.mutations
    },
    settings: {
      namespaced: true,
      state: settings.state,
      getters: settings.getters,
      actions: settings.actions,
      mutations: settings.mutations
    }
  }
});
